<script setup>
import { computed } from 'vue'
import { getI18n } from '@/plugins/i18n'
import { textColor } from '@/lib/utils'

import { GENERIC_TASK_ICON } from '@/stores/schedule.store'

const props = defineProps({
  taskType: {
    type: Object,
    default: null,
  },
})

const i18n = getI18n()

const style = computed(() => (props.taskType ? { backgroundColor: props.taskType.color, color: textColor(props.taskType.color) } : undefined))
</script>

<template>
  <span class="task-type-chip row inline no-wrap items-center">
    <q-icon
      :name="taskType?.icon ?? GENERIC_TASK_ICON"
      :color="taskType ? undefined : 'grey-7'"
      :style="taskType ? { color: taskType.color } : undefined"
      size="xs"
    />
    <q-chip
      dense
      size="sm"
      class="q-ma-none"
      :outline="!taskType"
      :label="taskType?.name ?? i18n.t('common.tasks.generic')"
      :style="style"
    />
  </span>
</template>

<style scoped>
.task-type-chip {
  gap: .25rem;
}
</style>
